import styled from "styled-components";

const PageWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export default PageWrap;
